
export default {
  props: {
    images: {
      type: Array,
      required: true,
    },
    gallerySettings: {
      type: Object,
      default() {
        return {
          speed: 100,
          slidesToShow: 1,
          centerMode: true,
          slidesToScroll: 1,
          variableWidth: true,
          focusOnSelect: true,
          lazyLoad: 'ondemand',
          asNavFor: '.room-nav',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                // dots: true,
              },
            },
          ],
        }
      },
    },
    navSettings: {
      type: Object,
      default() {
        return {
          slidesToShow: 5,
          centerMode: true,
          slidesToScroll: 1,
          variableWidth: true,
          focusOnSelect: true,
          lazyLoad: 'ondemand',
          asNavFor: '.room-gallery',
          swipeToSlide: true,
          arrows: false,
        }
      },
    },
  },

  computed: {
    rtl() {
      return this.dir === 'rtl'
    },
  },

  mounted() {
    this.$refs.gallery?.play()

    setTimeout(() => {
      this.$refs.gallery?.pause()
    }, 3000)
  },
}
